module.exports = __webpack_public_path__ + "img/gb-whatsapp-safe.e76aa99d.webp";